import { FD_IMAGE_URL } from '../../../constants'
import { FTUXType } from '../../../types/fd-ftux.types'

const BoltIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4498 0.857206C12.4498 0.481754 12.1856 0.150001 11.7978 0.0386371C11.4101 -0.0727269 10.9891 0.0622219 10.7591 0.371611L0.56348 14.0859C0.368484 14.3482 0.346721 14.6888 0.506959 14.9705C0.667197 15.2522 0.983058 15.4286 1.32726 15.4286H6.88852V23.143C6.88852 23.5184 7.15276 23.8501 7.54047 23.9615C7.9282 24.0728 8.34917 23.9379 8.57918 23.6285L18.7748 9.91423C18.9698 9.65193 18.9917 9.3113 18.8313 9.02959C18.6712 8.74788 18.3553 8.5715 18.011 8.5715H12.4498V0.857206Z" fill="white"/>
</svg>`

export const traditionalFDsFTUX: FTUXType = [
  [
    {
      type: 'TEXT',
      text: 'That’s great! If you like FDs,',
      className: 'text-[#D1ECFF] text-[20px] font-[400] leading-[150%] pb-3'
    },
    {
      type: 'TEXT',
      text: `You’ll love Power <br /> FD even more.`,
      className: 'text-[36px] font-[500] leading-[130%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `Get all the safety
<br /> you expect from
<br /> a traditional FD`,
      className: 'text-[32px] font-[500] leading-[130%] pb-9'
    },
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/safety-asset.svg`,
      maxWidth: '335px'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `With returns that <br /> actually excite you`,
      className: 'text-[32px] font-[500] leading-[130%] pb-9'
    },
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/returns-asset.svg`,
      maxWidth: '335px'
    },
    {
      type: 'TEXT',
      text: `More growth, with the same minimal risk.`,
      className: 'text-[#D1ECFF] text-[16px] font-[400] leading-[150%] pt-6'
    }
  ],
  [
    {
      type: 'TEXT',
      text: 'But...if you’re already invested in FDs',
      className: 'text-[18px] font-[500] leading-[150%] pb-2'
    },
    {
      type: 'TEXT',
      text: `Should you switch to <br /> Power FD?`,
      className: 'text-[32px] font-[500] leading-[130%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `We ran the math. <br />
The switch works`,
      className: 'text-[32px] font-[400] leading-[130%]'
    },
    {
      type: 'TEXT',
      text: `Every Single Time`,
      inlineStyles: { wordSpacing: '3px' },
      className: 'text-[32px] font-[500] leading-[120%] pb-8'
    },
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/switch-works-table.svg`,
      maxWidth: '335px'
    },
    {
      type: 'TEXT',
      text: `*Breaking an FD can cost 0.5-1% as penalty for withdrawing early.`,
      maxWidth: '335px',
      className: 'text-[#BAE3FF] text-[13px] font-[400] leading-[150%] !text-left pt-3'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `Need to access your <br />
investment before maturity?`,
      className: 'text-[18px] leading-[150%] font-[500] pb-3'
    },
    {
      type: 'TEXT',
      text: 'No fret. Withdraw <br /> easily anytime.',
      className: 'text-[32px] font-[500] leading-[120%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `<div style="display:flex;flex-direction:column"><div>Power FDs are</div><div style="display:flex; align-items:center; gap: 8px">lightning ${BoltIcon} fast</div></div>`,
      className: 'text-[32px] font-[500] leading-[120%] pb-8'
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/zero-hassle-icon.svg`,
      text: 'Zero hassle setup',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/bolt-icon.svg`,
      text: 'Book from your phone in just 5 mins',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/no-bank-acc-icon.svg`,
      text: 'Start without opening a bank a/c',
      className: 'w-full px-5',
      isActionable: false
    }
  ]
]
